let productConfiguration = "default";
export function usesSetProductConfiguration() {
  function setProductConfiguration(arg) {
    productConfiguration = arg;
  }
  function getProductConfiguration() {
    return productConfiguration;
  }
  return {
    setProductConfiguration,
    getProductConfiguration
  };
}
